module.exports = __webpack_public_path__ + "aecf8a976f9550e8f7b2e2c8068014e9.svg";